export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (menu, menus, moving, pages) {
      




































if (menu) {
pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003Cform\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003EName\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"name\""+pug_attr("value", menu.name, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
if (false) {
pug_html = pug_html + "\u003Cdiv class=\"form-group\"\u003E\u003Clabel\u003E\u003Cinput" + (" type=\"checkbox\" name=\"enabled\""+pug_attr("value", menu.enabled, true, true)) + "\u003E\nVisible\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fform\u003E\u003Chr\u003E";
if (moving) {
pug_html = pug_html + "\u003Cp class=\"item\"\u003E\u003Ca class=\"move-here clickable\" data-idx=\"-1\"\u003E Move here\u003C\u002Fa\u003E\u003C\u002Fp\u003E";
}
// iterate menu.items
;(function(){
  var $$obj = menu.items;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var item = $$obj[idx];
pug_html = pug_html + ("\u003Cp" + (" class=\"item\""+pug_attr("data-name", item.name, true, true)+pug_attr("data-idx", idx, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = item.name) ? "" : pug_interp)));
if (moving) {
}
else {
pug_html = pug_html + "\n(\u003Ca class=\"move-item clickable\"\u003Emove\u003C\u002Fa\u003E)\n\n\n(\u003Ca class=\"delete-item clickable\"\u003Edelete\u003C\u002Fa\u003E)";
}
pug_html = pug_html + "\u003C\u002Fp\u003E";
if (moving) {
pug_html = pug_html + "\u003Cp class=\"item\"\u003E\u003Ca" + (" class=\"move-here clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003E Move here\u003C\u002Fa\u003E\u003C\u002Fp\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var item = $$obj[idx];
pug_html = pug_html + ("\u003Cp" + (" class=\"item\""+pug_attr("data-name", item.name, true, true)+pug_attr("data-idx", idx, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = item.name) ? "" : pug_interp)));
if (moving) {
}
else {
pug_html = pug_html + "\n(\u003Ca class=\"move-item clickable\"\u003Emove\u003C\u002Fa\u003E)\n\n\n(\u003Ca class=\"delete-item clickable\"\u003Edelete\u003C\u002Fa\u003E)";
}
pug_html = pug_html + "\u003C\u002Fp\u003E";
if (moving) {
pug_html = pug_html + "\u003Cp class=\"item\"\u003E\u003Ca" + (" class=\"move-here clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003E Move here\u003C\u002Fa\u003E\u003C\u002Fp\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"form-label\"\u003EAdd page:\u003C\u002Flabel\u003E\u003Cselect class=\"add-page\"\u003E\u003Coption\u003E\u003C\u002Foption\u003E";
// iterate pages
;(function(){
  var $$obj = pages;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var page = $$obj[pug_index4];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", page.path, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = page.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var page = $$obj[pug_index4];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", page.path, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = page.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel class=\"form-label\"\u003EAdd submenu:\u003C\u002Flabel\u003E\u003Cselect class=\"add-menu\"\u003E\u003Coption\u003E\u003C\u002Foption\u003E";
// iterate menus
;(function(){
  var $$obj = menus;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var menu = $$obj[pug_index5];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", menu.name, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = menu.name) ? "" : pug_interp)) + " (menu)\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var menu = $$obj[pug_index5];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", menu.name, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = menu.name) ? "" : pug_interp)) + " (menu)\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cbutton class=\"delete\"\u003EDelete menu\u003C\u002Fbutton\u003E\u003Cbutton class=\"save\"\u003ESave\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
    }.call(this, "menu" in locals_for_with ?
        locals_for_with.menu :
        typeof menu !== 'undefined' ? menu : undefined, "menus" in locals_for_with ?
        locals_for_with.menus :
        typeof menus !== 'undefined' ? menus : undefined, "moving" in locals_for_with ?
        locals_for_with.moving :
        typeof moving !== 'undefined' ? moving : undefined, "pages" in locals_for_with ?
        locals_for_with.pages :
        typeof pages !== 'undefined' ? pages : undefined));
    ;;return pug_html;}